var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "grid-view matic-reconciliation" },
    [
      _c("div", { staticClass: "main-content" }, [
        _c("div", { staticClass: "section operations triggers" }, [
          _c(
            "div",
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "mini" },
                  on: { click: _vm.detailCancel }
                },
                [
                  _vm._v(
                    _vm._s(_vm.$t("Clearing.ReturnToReconciliationNewVersion"))
                  )
                ]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.isShow && _vm.redisKey,
                      expression: "!isShow && redisKey"
                    }
                  ],
                  attrs: { type: "primary", size: "mini" },
                  on: { click: _vm.reconciliation }
                },
                [_vm._v(_vm._s(_vm.$t("Clearing.StartReconciliation")))]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isShow,
                      expression: "isShow"
                    }
                  ],
                  attrs: {
                    disabled: !_vm.throttle,
                    type: "primary",
                    size: "mini"
                  },
                  on: { click: _vm.detailSave }
                },
                [_vm._v(_vm._s(_vm.$t("Clearing.Save")))]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isShow,
                      expression: "isShow"
                    }
                  ],
                  attrs: { type: "primary", size: "mini" },
                  on: {
                    click: function($event) {
                      return _vm.manualReconciliationFunc(false)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("Clearing.ManualReconciliation")))]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isShow,
                      expression: "isShow"
                    }
                  ],
                  attrs: { type: "primary", size: "mini" },
                  on: { click: _vm.cancelAll }
                },
                [_vm._v(_vm._s(_vm.$t("Clearing.CancelManualReconciliation")))]
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "footer-check" },
            [
              _c(
                "el-checkbox-group",
                {
                  on: { change: _vm.statusChanges },
                  model: {
                    value: _vm.checkList,
                    callback: function($$v) {
                      _vm.checkList = $$v
                    },
                    expression: "checkList"
                  }
                },
                [
                  _c("el-checkbox", { attrs: { label: "0" } }, [
                    _vm._v(_vm._s(_vm.$t("Clearing.ShowAllReconciliationFees")))
                  ]),
                  _c("el-checkbox", { attrs: { label: "1" } }, [
                    _vm._v(_vm._s(_vm.$t("Clearing.ShowFullyReconciledFees")))
                  ]),
                  _c("el-checkbox", { attrs: { label: "2" } }, [
                    _vm._v(
                      _vm._s(_vm.$t("Clearing.ShowPartiallyReconciledFees"))
                    )
                  ]),
                  _c("el-checkbox", { attrs: { label: "3" } }, [
                    _vm._v(_vm._s(_vm.$t("Clearing.ShowUnmatchedFees")))
                  ])
                ],
                1
              )
            ],
            1
          )
        ]),
        _c(
          "p",
          { staticClass: "instructions section" },
          [
            _vm._v(" " + _vm._s(_vm.$t("Clearing.Note")) + " "),
            _c("span", { staticStyle: { color: "green" } }, [
              _vm._v(_vm._s(_vm.$t("Clearing.Green")))
            ]),
            _vm._v(
              _vm._s(
                _vm.$t("Clearing.IndicatesReconciliationResultIsConsistent")
              ) + " "
            ),
            _c("span", { staticStyle: { color: "#000" } }, [
              _vm._v(_vm._s(_vm.$t("Clearing.Black")))
            ]),
            _vm._v(
              _vm._s(_vm.$t("Clearing.IndicatesCorrespondingFeeNotFound")) + " "
            ),
            _c("span", { staticStyle: { color: "red" } }, [
              _vm._v(_vm._s(_vm.$t("Clearing.Red")))
            ]),
            _vm._v(
              _vm._s(_vm.$t("Clearing.IndicatesAmountInconsistency")) + " "
            ),
            _c("span", { staticStyle: { color: "orange" } }, [
              _vm._v(_vm._s(_vm.$t("Clearing.Orange")))
            ]),
            _vm._v(
              _vm._s(
                _vm.$t("Clearing.IndicatesManualReconciliationCompleted")
              ) + " "
            ),
            _c(
              "el-checkbox",
              {
                staticStyle: { "margin-left": "15px" },
                model: {
                  value: _vm.sendEmail,
                  callback: function($$v) {
                    _vm.sendEmail = $$v
                  },
                  expression: "sendEmail"
                }
              },
              [
                _vm._v(
                  _vm._s(_vm.$t("CargoMsg.Cargo_SendEmailByReconciliationDiff"))
                )
              ]
            )
          ],
          1
        ),
        _c(
          "p",
          {
            staticClass: "instructions section",
            staticStyle: { color: "red" }
          },
          [_vm._v(_vm._s(_vm.$t("Clearing.IfEtcPleaseGoModule")))]
        ),
        _c("div", { staticClass: "details-list grid-wrapper" }, [
          _c("div", { staticClass: "details-content grid-wrapper" }, [
            _c(
              "div",
              { staticClass: "left" },
              [
                _c("p", [
                  _vm._v(_vm._s(_vm.$t("Clearing.ImportExternalFees")))
                ]),
                _c("cargo-ag-grid", {
                  attrs: {
                    "config-module": "20220610",
                    "grid-options": _vm.externalGridOptions,
                    "column-defs": _vm.externalColumnDefs,
                    "row-data": _vm.externalData
                  }
                }),
                _c("div", { staticClass: "uniform" }, [
                  _c(
                    "div",
                    [
                      _c("cargo-pagination", {
                        attrs: {
                          "config-module": "41001220012",
                          total: _vm.externalPaging.total,
                          page: _vm.externalPaging.pageNum,
                          limit: _vm.externalPaging.pageSize
                        },
                        on: {
                          "update:page": function($event) {
                            return _vm.$set(
                              _vm.externalPaging,
                              "pageNum",
                              $event
                            )
                          },
                          "update:limit": function($event) {
                            return _vm.$set(
                              _vm.externalPaging,
                              "pageSize",
                              $event
                            )
                          },
                          pagination: function($event) {
                            return _vm.getList()
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.externalPaging.total !== 0 && _vm.redisKey,
                          expression: "externalPaging.total !== 0 && redisKey"
                        }
                      ],
                      staticClass: "combined"
                    },
                    _vm._l(_vm.externalAmountList, function(item, index) {
                      return _c("p", { key: index, staticClass: "usd" }, [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("Message.AllPage1")) +
                            _vm._s(item.total) +
                            _vm._s(_vm.$t("Message.Transactions")) +
                            "， "
                        ),
                        _c("span", { staticStyle: { "font-weight": "bold" } }, [
                          _vm._v(_vm._s(item.currency) + "：")
                        ]),
                        _c(
                          "span",
                          { staticStyle: { "font-style": "oblique" } },
                          [_vm._v(_vm._s(item.amount.toFixed(2)))]
                        )
                      ])
                    }),
                    0
                  )
                ])
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "right" },
              [
                _c("p", [
                  _vm._v(_vm._s(_vm.$t("Clearing.SystemInternalFees")))
                ]),
                _c("cargo-ag-grid", {
                  attrs: {
                    "config-module": "20220611",
                    "grid-options": _vm.internalGridOptions,
                    "column-defs": _vm.internalColumnDefs,
                    "row-data": _vm.internalData
                  }
                }),
                _c("div", { staticClass: "uniform" }, [
                  _c(
                    "div",
                    [
                      _c("cargo-pagination", {
                        attrs: {
                          "config-module": "41001220013",
                          total: _vm.internalPaging.total,
                          page: _vm.internalPaging.pageNum,
                          limit: _vm.internalPaging.pageSize
                        },
                        on: {
                          "update:page": function($event) {
                            return _vm.$set(
                              _vm.internalPaging,
                              "pageNum",
                              $event
                            )
                          },
                          "update:limit": function($event) {
                            return _vm.$set(
                              _vm.internalPaging,
                              "pageSize",
                              $event
                            )
                          },
                          pagination: function($event) {
                            return _vm.getList()
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.internalPaging.total !== 0 && _vm.redisKey,
                          expression: "internalPaging.total !== 0 && redisKey"
                        }
                      ],
                      staticClass: "combined"
                    },
                    _vm._l(_vm.internalAmountList, function(item, index) {
                      return _c("p", { key: index, staticClass: "usd" }, [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("Message.AllPage1")) +
                            _vm._s(item.total) +
                            _vm._s(_vm.$t("Message.Transactions")) +
                            "， "
                        ),
                        _c("span", { staticStyle: { "font-weight": "bold" } }, [
                          _vm._v(_vm._s(item.currency) + "：")
                        ]),
                        _c(
                          "span",
                          { staticStyle: { "font-style": "oblique" } },
                          [_vm._v(_vm._s(item.amount.toFixed(2)))]
                        )
                      ])
                    }),
                    0
                  )
                ])
              ],
              1
            )
          ])
        ])
      ]),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            visible: _vm.rulesDialog,
            title: _vm.$t("Clearing.SelectReconciliationRules"),
            width: "500px",
            "show-close": false
          },
          on: {
            "update:visible": function($event) {
              _vm.rulesDialog = $event
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "app-main-inner-row",
              staticStyle: { "padding-bottom": "10px" }
            },
            [
              _c(
                "div",
                { staticStyle: { margin: "0 auto", width: "100%" } },
                [
                  _c("cargo-ag-grid", {
                    attrs: {
                      "grid-options": _vm.rulesGridOptions,
                      "column-defs": _vm.rulesColumnDefs,
                      "row-data": _vm.rulesData
                    },
                    on: { gridReady: _vm.onCostGridReady }
                  }),
                  _c("p", { staticStyle: { margin: "5px 0 0 0" } }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t("Clearing.IfMaintainReconciliationRulesClick")
                      ) + " "
                    ),
                    _c(
                      "span",
                      {
                        staticStyle: { color: "#4283ff", cursor: "pointer" },
                        on: { click: _vm.jump }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "Clearing.ReconciliationRuleEngineConfiguration"
                            )
                          )
                        )
                      ]
                    )
                  ])
                ],
                1
              )
            ]
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "mini" },
                  on: { click: _vm.rulesDetermine }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Confirm")))]
              ),
              _c(
                "el-button",
                { attrs: { size: "mini" }, on: { click: _vm.rulesCancel } },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Cancel")))]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }